module.exports = __webpack_public_path__ + "static/media/o21.ff8ad179.png";